import { useEffect, useState } from 'react'
import Swal from 'sweetalert2';
import { AdminPublicInfo } from '../../Api/Admin/models'
import { GetCbuResponse } from '../../Api/CBU/models'
import { fetchStaticButton } from '../../Api/Buttons/Buttons'
import { Button } from '../../Api/Buttons/models'
import toast from 'react-hot-toast';
import { useGetTimeForHistory } from '../Coins/useGetTimeForHistory';
import { unlockUser } from '../../Api/UserPanel/UserPanel';

interface Props {
    adminInfo: AdminPublicInfo | null
    setForm: (form: any) => void
    setLoading: (loading: boolean) => void
    setDropdownOpen: (dropdownOpen: boolean) => void
    fetchedData: GetCbuResponse | null
    form: any
    loading: boolean
    setHistorial: (historial: any[]) => void
    historial: any[]
    setErrorQuantities: (errorQuantities: number) => void
    errorQuantities: number
    showHistory: boolean
    setShowHistory: (showHistory: boolean) => void
}



export const useUnblockUser = ({
    setForm,
    setLoading,
    form,
    loading,
    setHistorial,
    historial,
    setErrorQuantities,
    errorQuantities,
    showHistory,
    setShowHistory,
}: Props) => {

    const { getTime } = useGetTimeForHistory()

    const [messagesUnblock, setMessagesUnblock] = useState<Button>({
        id: '',
        name: '',
        category: '',
        createdAt: '',
        updatedAt: '',
        OwnerId: '',
        Messages: []
    })


    // MAIN FUNCTION
    const handleUnblockUser = async () => {
        if (loading) { return }
        if (form.name.length < 3) { Swal.fire({ text: 'Para desbloquear ingresa el nombre de usuario completo en el campo de arriba' }); return }
        setLoading(true)


        const copyMessage = async (text: string) => {
            await navigator.clipboard.writeText(text)
            let updatedMessage = text
                .replaceAll('__USUARIO__', (form.name))
            await navigator.clipboard.writeText(updatedMessage);
        }

        let randomIndex = Math.floor(Math.random() * messagesUnblock?.Messages?.length);
        let randomValue = messagesUnblock?.Messages[randomIndex];
        if (randomValue) copyMessage(randomValue.text)

        let originalName = form.name
        setForm({ name: '' })




        try {
            const result = await unlockUser({ name: originalName })

            if (result?.status === 200) {
                toast.success(`Usuario ${originalName} desbloqueado`)
                let record = { user: originalName, hour: getTime(), success: true, type: 'Desbloquear' }
                setHistorial([...historial, record])
            } else {
                let record = { user: originalName, hour: getTime(), success: false, type: 'Desbloquear', info: result.data }
                setHistorial([...historial, record])
                if (!showHistory) setErrorQuantities(errorQuantities + 1)
                const errorMessage = result?.response?.data?.msg ?? 'Ha habido un error. Reinicia e intenta de nuevo.'
                Swal.fire({ icon: 'error', text: errorMessage });
            }

        } catch (error: any) {
            let errorMessage = 'ERROR: No se ha podido desbloquear, el usuario ya está desbloqueado o no existe.'
            if (error?.response?.data?.msg) {
                errorMessage = error.response.data.msg
            }
            let record = { user: originalName, hour: getTime(), success: false, type: 'Desbloquear', info: 'ERROR: No se ha podido desbloquear' }
            setHistorial([...historial, record])
            if (!showHistory) setErrorQuantities(errorQuantities + 1)
            Swal.fire({ icon: 'error', text: errorMessage });
        } finally {
            setLoading(false)
        }



    }


    useEffect(() => {
        fetchStaticButton('static_unblock').then((res) => {
            setMessagesUnblock(res)
        })
    }, [])




    return {
        handleUnblockUser,
        historial,
        errorQuantities,
        showHistory,
        setShowHistory,
        setErrorQuantities

    }





}
